/** @jsx jsx */
import { jsx, css, Theme } from '@emotion/react'
import cn from 'classnames'
import { isDarkMode } from 'styles/UsePaletteMode'

interface TestIdProps {
  'data-testid'?: string
}

// We use an exact copy of this element in the index.html and the styles are kept in /public/style.css
export function FullPageLoader(props: TestIdProps) {
  return (
    <div className="vf-full-page-loader" css={fullPageStyle} {...props}>
      <WidgetLoader centered />
    </div>
  )
}

export function WidgetLoader({
  centered = true,
  className,
  ...restOfProps
}: TestIdProps & { centered?: boolean; className?: string }) {
  return (
    <div className={cn('vf-widget-loader', className)} css={style(centered)} {...restOfProps}>
      <div className="vf-ring" css={ringStyle}>
        <img src="/assets/square-logo-72x72.png" alt="Vendorflow Square Logo" />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  )
}

const fullPageStyle = (theme: Theme) => css`
  background-color: ${theme.palette ? theme.palette.background.paper : 'white'};
`
const style = (centered: boolean) => (theme: Theme) =>
  css`
    background-color: ${theme.palette ? theme.palette.background.paper : 'white'};
    justify-content: ${centered ? 'center' : 'flex-start'};
    background-image: ${theme.palette?.mode && isDarkMode(theme)
      ? `linear-gradient(
            ${theme.custom.gradients.linear.black['5']},
            ${theme.custom.gradients.linear.black['5']}
          )`
      : 'inherit'};
  `
const ringStyle = (theme: Theme) =>
  theme.palette
    ? css`
        & div {
          border-color: ${theme.palette.primary.dark} transparent transparent transparent;
        }
      `
    : undefined
export const smallLoaderStyle = css`
  & .vf-ring {
    height: 2rem;
    width: 2rem;
  }
  & .vf-ring div {
    height: 1.25rem;
    width: 1.25rem;
    border-width: 1px;
  }
  & img {
    height: 0.75rem;
    width: 0.75rem;
  }
`
